var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "export-me-line-copy",
    transform: "translate(-0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "invisible-sizing-box",
    fillOpacity: 0,
    fill: "#CC0000",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "microphone",
    transform: "translate(4.000000, 0.000000)",
    fill: "#0076cc",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.2508 0 C 5.3513 0 3.0008 2.3505 3.0008 5.25 L 3.0008 12 C 3.0008 14.8995 5.3513 17.25 8.2508 17.25 C 11.1503 17.25 13.5008 14.8995 13.5008 12 L 13.5008 5.25 C 13.5008 2.3505 11.1503 0 8.2508 0 Z Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25,24 C7.836,24 7.5,23.664 7.5,23.25 L7.5,20.216 C3.266,19.835 0,16.293 0,12 L0,9.75 C0,9.336 0.336,9 0.75,9 C1.164,9 1.5,9.336 1.5,9.75 L1.5,12 C1.5,15.722 4.528,18.75 8.25,18.75 C11.972,18.75 15,15.722 15,12 L15,9.75 C15,9.336 15.336,9 15.75,9 C16.164,9 16.5,9.336 16.5,9.75 L16.5,12 C16.5,16.293 13.234,19.835 9,20.216 L9,23.25 C9,23.664 8.664,24 8.25,24 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.2edd39b271a3301477b81d94354874b1.svg";
export { ForwardRef as ReactComponent };